import { RefreshLight } from '@repo/go-icons';
import { Button } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { BasicParametersEntity } from '../BasicParameters.entity';
import styles from '../BasicParameters.module.scss';
import type { BasicParametersStore } from '../BasicParameters.store';
import { WellboresSelect } from '../selects/WellboresSelect';
import { WellsSelect } from '../selects/WellsSelect';

type Props = {
  store: BasicParametersStore;
  screen: BasicParametersEntity;
};

export const HeaderSection = observer(function HeaderSection({ store, screen }: Props) {
  const { t } = useTranslation();
  const { currentWellbore } = store;

  const {
    view: { item: itemView },
  } = screen;

  return (
    <div className={styles.header}>
      <div className={styles.headerSelectsWrapper}>
        <div className={styles.headerSelectWrapper}>
          <span>{t('settings:well')}</span>
          <WellsSelect itemView={itemView} store={store} />
        </div>
        <div className={styles.headerSelectWrapper}>
          <span>{t('settings:borehole')}</span>
          <WellboresSelect store={store} />
        </div>
      </div>
      <Button
        disabled={!currentWellbore || store.isBaseParamsLoading}
        icon={<RefreshLight />}
        onClick={() => store.autoSetBaseParams()}
        loading={store.isBaseParamsLoading}
      >
        {t('settings:autoFill')}
      </Button>
    </div>
  );
});
